<mat-label [hidden]="hideLabel">
  {{ labelOverride || fgInfo?.label }}{{ formControl['condrequired'] || fgInfo?.required ? '*' : '' }}
  <mat-icon [hidden]="!tooltipText" [matTooltip]="tooltipText" [matTooltipPosition]="'after'" [attr.aria-label]="'Tooltip: ' + tooltipText" tabindex="0">
    help
  </mat-icon>
</mat-label>
<mat-hint>{{ hint }}</mat-hint>
<ng-container *ngFor="let errorDefinition of errorDefinitions">
  <p *ngIf="formControl.touched && errorDefinition.showFunction()" class="text-warn">
    {{ errorDefinition.errorMessage(formControl) }}
  </p>
</ng-container>
